<template>
  <b-card
    v-if="data"
    text-variant="center"
    class="card card-congratulations"
  >
    <!-- images -->
    <b-img
      v-if="data.totalSale > 15"
      :src="require('@/assets/images/elements/decore-left.png')"
      class="congratulations-img-left"
    />
    <b-img
      v-if="data.totalSale > 15"
      :src="require('@/assets/images/elements/decore-right.png')"
      class="congratulations-img-right"
    />
    <!--/ images -->

    <b-avatar
      v-if="data.totalSale > 15"
      variant="primary"
      size="70"
      class="shadow mb-2"
    >
      <feather-icon
        size="28"
        icon="AwardIcon"
      />
    </b-avatar>
    <h1
      v-if="data.totalSale > 15"
      class="mb-1 mt-50 text-white"
    >
      Parabéns {{ data.name }},
    </h1>
    <h1
      v-else
      class="mb-1 mt-50 text-white"
    >
      {{ data.name }},
    </h1>
    <b-card-text class="m-auto w-75">
      A conversão neste período foi de <strong>{{ data.totalSale }}%</strong>. Nossa média é de 15% a 20%.
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BAvatar, BCardText,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BAvatar,
    BImg,
    BCardText,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
